import { Injectable } from '@angular/core';

export class Settings {
    constructor(
        public rtl: boolean,
        public adminSidenavIsOpened: boolean,
        public adminSidenavIsPinned: boolean,
        public adminSidenavUserBlock: boolean,
        public userSidenavIsOpened: boolean,
        public userSidenavIsPinned: boolean,
        public userSidenavUserBlock: boolean,
        public mainToolbarFixed: boolean) { }
}

@Injectable()
export class AppSettings {
    public settings = new Settings(

        false,       // true = rtl, false = ltr
        true,        // adminSidenavIsOpened
        true,        // adminSidenavIsPinned 
        true,        // adminSidenavUserBlock 
        true,        // userSidenavIsOpened
        true,        // userSidenavIsPinned 
        true,        // userSidenavUserBlock 
        false        // mainToolbarFixed
    )
}